import { TwitchStream } from '../types';

const GTA_V_GAME_ID = '32982';

/** NPXL only includes roster members currently live in GTA V. */
export const filterNpxlStreams = <T extends TwitchStream>(streams: T[], roster: string[]): T[] => {
  const logins = new Set(roster.map(login => login.toLowerCase()));
  const seen = new Set<string>();
  return streams.filter(stream => {
    const login = stream.user_login.toLowerCase();
    if (stream.type !== 'live' || stream.game_id !== GTA_V_GAME_ID || !logins.has(login) || seen.has(login)) return false;
    seen.add(login);
    return true;
  });
};
